import { Dialog } from "components/common";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { promptedRoute } from "route/SlideRoute";
import { useRootSelector, useRootDispatch } from "../../../store/hooks";
import { BarItems, ItemBar } from "../../common/itemBar/ItemBar";
import { SlideoutNotifications } from "../../common/notification/SlideoutNotifications";
import { clearSlideoutNotifications } from "../../../store/notification/notification-slice";
import classes from "./SliderPageWrapper.module.scss";

export interface SliderPageWrapperProps {
  headerTitle: string;
  warningMessage?: React.ReactNode;
  quickbarItems?: { items: BarItems[]; progress: string };
  children?: React.ReactNode;
  closeButtonHandler?: () => void;
  preserveHeadingCase?: boolean;
}

export const SliderPageWrapper: React.FC<SliderPageWrapperProps> = ({
  headerTitle,
  warningMessage,
  children,
  quickbarItems,
  closeButtonHandler,
  preserveHeadingCase = false,
}) => {
  const { isSlideOpen, isNavOpen, pageDetail } = useRootSelector(
    (state) => state.common,
  );

  const { t } = useTranslation(["common"]);
  const dispatch = useRootDispatch();

  const [showDialog, setShowDialog] = useState(false);

  const closeClickHandler = () => {
    const res = pageChecker();
    if (res) {
      closeDrawer();
      if (closeButtonHandler) closeButtonHandler();
    } else {
      setShowDialog(true);
    }
  };

  const closeDrawer = () => {
    const drawer: any = document.getElementsByTagName("ft-drawer")[0];
    if (drawer) {
      drawer.open = false;
      dispatch(clearSlideoutNotifications());
    }
  };

  const pageChecker = () => {
    const res = promptedRoute.filter((single) => {
      return pageDetail?.id === single;
    });

    if (res.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const dialogAction = () => {
    setShowDialog(false);
    closeDrawer();
  };

  return (
    <>
      <section
        className={[classes.Wrapper, isNavOpen ? classes.NavOpen : ""].join(
          " ",
        )}
      >
        <div className={classes.Header}>
          <ft-icon
            data-testid="slide-page-close-icon"
            onClick={closeClickHandler}
            class={classes.Icon}
            title={t("common:close")}
          >
            close
          </ft-icon>
        </div>

        {isSlideOpen ? (
          <div className={classes.stickyNotification}>
            {" "}
            <SlideoutNotifications isOpen={isSlideOpen} />{" "}
          </div>
        ) : (
          ""
        )}
        <div className={classes.Container}>
          <p
            className={[
              classes.Heading,
              preserveHeadingCase ? classes.PreserveCase : "",
            ].join(" ")}
          >
            {preserveHeadingCase ? headerTitle : headerTitle.toLowerCase()}
          </p>
          {warningMessage ? warningMessage : <></>}
          {quickbarItems ? (
            <div className={classes.InnerWrapper}>
              <ItemBar
                items={quickbarItems.items}
                progress={quickbarItems.progress}
              />
            </div>
          ) : null}
          {children}
        </div>
      </section>
      {showDialog ? (
        <Dialog
          icon="warning_amber"
          primaryActionLabel={t("common:close")}
          primaryActionHandler={dialogAction}
          dialogClosed={() => setShowDialog(false)}
          type="warning"
          closeIcon
        >
          {t("common:reload_site")}
        </Dialog>
      ) : null}
    </>
  );
};
